export const SourceHomebaseComponent = "homebasecomponents";
export const SourceHomebaseListComponent = "homebasecomponents/getmaindata";

export const TitleHomebaseComponent = {
  list: "HomebaseComponent List",
  edit: "Edit HomebaseComponent",
  create: "Create HomebaseComponent",
  detail: "HomebaseComponent Detail",
};
